import { render, staticRenderFns } from "./testPaperList.vue?vue&type=template&id=0d4bdafb&scoped=true"
import script from "./testPaperList.vue?vue&type=script&lang=js"
export * from "./testPaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4bdafb",
  null
  
)

export default component.exports